import { Center, Skeleton } from '@chakra-ui/react';
import GenericDataTableBtn from '@Modules/core/components/table/GenericDataTableBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TConsultingValidSettlements = {
  primaryKey: string | number,
  date: string,
  tc: string,
  currencyCode: string,
  dFeesType: string,
  dAmount: string,
  dFees: string,
  dNetAmount: string,
  cFeesType: string,
  cAmount: string,
  cFees: string,
  cNetAmount: string,

};

type Props = {
  isLoading: boolean | undefined,
  handleBtn: (row: any) => void,
};

const columnHelper = createColumnHelper<TConsultingValidSettlements>();

export function getConsultingValidSettlementsDataTableColumns({ isLoading, handleBtn }: Props) {
  return [
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('tc', {
      id: 'tc',
      header: 'TC',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('currencyCode', {
      id: 'currencyCode',
      header: 'Devise',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dFeesType', {
      id: 'dFeesType',
      header: 'Type Frai.D',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dAmount', {
      id: 'dAmount',
      header: 'Montant.D',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dFees', {
      id: 'dFees',
      header: 'Frai.D',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dNetAmount', {
      id: 'dNetAmount',
      header: 'M.Net.D',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cFeesType', {
      id: 'cFeesType',
      header: 'Type Frai.C',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cAmount', {
      id: 'cAmount',
      header: 'Montant.C',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cFees', {
      id: 'cFees',
      header: 'Frai.C',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cNetAmount', {
      id: 'cNetAmount',
      header: 'M.Net.C',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

  ];
}
